export function generateUuidV4(): string {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }

  const uuidV4Pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";

  return uuidV4Pattern.replace(/[xy]/g, (placeholder: string) => {
    const randomNibble = (Math.random() * 16) | 0;
    const adjustedNibble = placeholder === "x" ? randomNibble : (randomNibble & 0x3) | 0x8;

    return adjustedNibble.toString(16);
  });
}
